import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { SaveButton } from "../../../components/Buttons";

export const Profile = () => {
    document.title = "Profil";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Profil", value: "/settings/profile", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Profil</h2>
                    <p>
                        Nümunədə istifadəçinin profili ilə bağlı məlumatlar göstərilib. Şirkət adı və telefon nömrəsi qaimələrdə əks olunacaq. Həmçinin,
                        müştərilərə veriləcək cashback faizini bu səhifədə təyin edirsiniz. Məlumatları yazdıqdan sonra <SaveButton /> düyməsini sıxmaq
                        lazımdır.
                    </p>
                    <img src="/images/settings/profile.gif" alt="Profil" />
                </article>
            </div>
        </div>
    );
};
